export const WorkerRosterRouting = [
  {
    path: "/labor/WorkerRosterManagement/list",
    name: "labor-WorkerRosterManagement-list",
    meta: { title: "工人名册管理" },
    component: () =>
      import(
        /* webpackChunkName: "labor-team-list" */ "@/views/labor/Worker-Roster-Management/list/index.vue"
      ),
  },
  {
    path: "/labor/WorkerRosterManagement/detail/:id",
    name: "labor-WorkerRosterManagement-detail",
    meta: { title: "工人详情" },
    component: () =>
      import(
        /* webpackChunkName: "labor-team-list" */ "@/views/labor/Worker-Roster-Management/form-detail/index.vue"
      ),
  },
];
